import React, { useState } from 'react';
import './EmailCapture.css';
import { trackEmailSubmitted } from '../utils/analytics';

function EmailCapture({ score, verdict, onSubmit }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      setErrorMsg('Please enter a valid email address.');
      return;
    }
    setErrorMsg('');
    setStatus('loading');
    try {
      await onSubmit(trimmed);
      trackEmailSubmitted({ score, verdict });
      setStatus('success');
    } catch {
      setStatus('error');
      setErrorMsg('Something went wrong. Please try again.');
    }
  };

  if (status === 'success') {
    return (
      <div className="card email-capture-card email-capture-success">
        <span className="email-capture-check">✅</span>
        <p>You're on the list! We'll send practical affordability tips to help you make smarter purchase decisions.</p>
      </div>
    );
  }

  return (
    <div className="card email-capture-card">
      <h3>📬 Get smarter about big purchases</h3>
      <p className="email-capture-sub">
        Occasional tips on affordability, budgeting, and making confident purchase decisions. No spam, unsubscribe any time.
      </p>
      <form className="email-capture-form" onSubmit={handleSubmit} noValidate>
        <input
          type="email"
          className="email-capture-input"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={status === 'loading'}
          aria-label="Email address"
        />
        <button
          type="submit"
          className="email-capture-btn"
          disabled={status === 'loading'}
        >
          {status === 'loading' ? 'Sending…' : 'Subscribe'}
        </button>
      </form>
      {errorMsg && <p className="email-capture-error">{errorMsg}</p>}
      <p className="email-capture-privacy">
        We don't share your email. See our <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
      </p>
    </div>
  );
}

export default EmailCapture;
